export default __webpack_public_path__ + "static/media/Mindblaze Ring.78eebb53.jpg";